// Revisado: 2026-02-21 [I18n Scan] - [Meta SEO y UI]
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../shared/SEO';

const RequestPassChange = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message || t('RequestPassChange.success_email'));
            } else {
                setError(data.message || t('RequestPassChange.error_sending'));
            }
        } catch (err) {
            setError(t('RequestPassChange.error_network'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
            <SEO title={t('MetaRequestPassChange.title')} description={t('MetaRequestPassChange.description')} />
            <div className="w-full max-w-md bg-gray-800 rounded-lg shadow-lg p-8">
                <h2 className="text-2xl font-bold mb-6 text-center text-blue-400">{t('RequestPassChange.title')}</h2>

                {message ? (
                    <div className="bg-green-900/50 border border-green-500 text-green-200 p-4 rounded mb-6">
                        {message}
                        <div className="mt-4 text-center">
                            <button
                                onClick={() => navigate('/login')}
                                className="text-blue-400 hover:text-blue-300 underline"
                            >
                                {t('RequestPassChange.return_link')}
                            </button>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                                {t('RequestPassChange.email_label')}
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded focus:ring-2 focus:ring-blue-500 focus:outline-none text-white"
                                placeholder="email@example.com"
                            />
                        </div>

                        {error && (
                            <div className="text-red-400 text-sm text-center bg-red-900/20 p-2 rounded">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className={`w-full py-2 px-4 rounded font-bold text-white transition-colors ${loading
                                ? 'bg-gray-600 cursor-not-allowed'
                                : 'bg-blue-600 hover:bg-blue-700'
                                }`}
                        >
                            {loading ? t('RequestPassChange.button_loading') : t('RequestPassChange.button')}
                        </button>

                        <div className="text-center mt-4">
                            <button
                                type="button"
                                onClick={() => navigate('/login')}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                {t('RequestPassChange.cancel_link')}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default RequestPassChange;
